(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["category-image-rotator"] && !Shopify.designMode) return;
  try {
    class CategoryImageRotator extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
      this.images = [];
      this.index = 0;
      this.baseIndex = 0;
      this.reducedMotion = false;
      this.stopRotation = this.stopRotation.bind(this);
      this.startRotation = this.startRotation.bind(this);
      this.handleMouseEnter = this.handleMouseEnter.bind(this);
      this.handleMouseLeave = this.handleMouseLeave.bind(this);
      this.handleVisibility = this.handleVisibility.bind(this);
    }

    connectedCallback() {
      this.images = Array.from(this.querySelectorAll(':scope > .category-image-rotator__image'));

      if (this.images.length === 0) return;

      this.index = this.getInitialIndex();
      this.showImage(this.index);
      this.dataset.ready = 'true';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.images.length === 1) return;

      if (this.dataset.mode === 'automatic' || this.dataset.hoverEnabled === 'true') {
        this.addEventListener('mouseenter', this.handleMouseEnter);
        this.addEventListener('mouseleave', this.handleMouseLeave);
        document.addEventListener('visibilitychange', this.handleVisibility);
      }

      if (this.dataset.mode === 'automatic') this.startRotation();
    }

    disconnectedCallback() {
      this.stopRotation();
      this.removeEventListener('mouseenter', this.handleMouseEnter);
      this.removeEventListener('mouseleave', this.handleMouseLeave);
      document.removeEventListener('visibilitychange', this.handleVisibility);
    }

    getInitialIndex() {
      const limit = this.getPrimaryLimit();
      if (this.dataset.mode !== 'daily') return Math.floor(Math.random() * limit);

      const date = new Date();
      const day = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      const seed = `${this.dataset.rotationKey || ''}-${day}`;
      let hash = 0;

      for (const character of seed) {
        hash = (hash * 31 + character.charCodeAt(0)) >>> 0;
      }

      return hash % limit;
    }

    getPrimaryLimit() {
      return Math.max(1, Math.min(Number(this.dataset.primaryCount || 4), this.images.length));
    }

    getHoverLimit() {
      return Math.max(1, Math.min(Number(this.dataset.hoverCount || 4), this.images.length));
    }

    showImage(index) {
      this.images.forEach((image, imageIndex) => {
        const isActive = imageIndex === index;
        image.classList.toggle('is-active', isActive);
        image.setAttribute('aria-hidden', String(!isActive));
      });
    }

    startRotation(type = 'primary') {
      if (this.timer || document.hidden || this.reducedMotion) return;

      const isHoverRotation = type === 'hover';
      const interval = Number(isHoverRotation ? this.dataset.hoverInterval || 2 : this.dataset.primaryInterval || 5) * 1000;
      const limit = isHoverRotation ? this.getHoverLimit() : this.getPrimaryLimit();
      this.timer = window.setInterval(() => {
        this.advanceImage(limit);
      }, interval);
    }

    advanceImage(limit = this.getPrimaryLimit()) {
      this.index = (this.index + 1) % limit;
      this.showImage(this.index);
    }

    stopRotation() {
      window.clearInterval(this.timer);
      this.timer = null;
    }

    handleMouseEnter() {
      if (this.dataset.hoverEnabled === 'true') {
        this.baseIndex = this.index;
        if (this.dataset.mode === 'automatic') this.stopRotation();
        this.advanceImage(this.getHoverLimit());
        if (this.dataset.hoverContinuous === 'true') this.startRotation('hover');
      }
    }

    handleMouseLeave() {
      if (this.dataset.hoverEnabled === 'true') {
        this.stopRotation();
        this.index = this.baseIndex;
        this.showImage(this.index);
        if (this.dataset.mode === 'automatic') this.startRotation('primary');
      }
    }

    handleVisibility() {
      if (document.hidden) {
        this.stopRotation();
      } else if (
        this.dataset.hoverEnabled === 'true' &&
        this.dataset.hoverContinuous === 'true' &&
        this.matches(':hover')
      ) {
        this.startRotation('hover');
      } else if (this.dataset.mode === 'automatic') {
        this.startRotation('primary');
      }
    }
  }

  if (!customElements.get('category-image-rotator')) {
    customElements.define('category-image-rotator', CategoryImageRotator);
  }
  } catch(e) { console.error(e); }
})();

})();
